'use strict';

var React = require('react');
var PropTypes = require('prop-types');
var style = require('./IconBase.css');

var IconBase = function IconBase(props) {
    var children = props.children,
        viewBox = props.viewBox,
        spaceRight = props.spaceRight,
        spaceLeft = props.spaceLeft;


    return React.createElement(
        'svg',
        {
            className: style.icon + ' ' + (spaceRight && style.spaceRight) + ' ' + (spaceLeft && style.spaceLeft),
            viewBox: viewBox,
            style: props.style
        },
        children
    );
};

IconBase.propTypes = {
    viewBox: PropTypes.string,
    children: PropTypes.node,
    spaceRight: PropTypes.bool,
    spaceLeft: PropTypes.bool,
    style: PropTypes.object
};

IconBase.defaultProps = {
    viewBox: '0 0 1024 1024',
    spaceRight: false,
    style: {}
};

// module.exports needed to generate right icons
module.exports = IconBase;